/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Consumer_NameInputs */

const en_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumer name`)
};

const de_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Verbrauchers`)
};

const fr_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du consommateur`)
};

const es_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del consumidor`)
};

const it_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del consumatore`)
};

const nl_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van consument`)
};

const pl_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko konsumenta`)
};

const fi_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuluttajan nimi`)
};

const da_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbrugerens navn`)
};

const sv_consumer_declaration_consumer_name = /** @type {(inputs: Consumer_Declaration_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsumentens namn`)
};

/**
* | output |
* | --- |
* | "Consumer name" |
*
* @param {Consumer_Declaration_Consumer_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_consumer_name = /** @type {((inputs?: Consumer_Declaration_Consumer_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Consumer_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_consumer_name(inputs)
	if (locale === "fr") return fr_consumer_declaration_consumer_name(inputs)
	if (locale === "es") return es_consumer_declaration_consumer_name(inputs)
	if (locale === "it") return it_consumer_declaration_consumer_name(inputs)
	if (locale === "nl") return nl_consumer_declaration_consumer_name(inputs)
	if (locale === "pl") return pl_consumer_declaration_consumer_name(inputs)
	if (locale === "fi") return fi_consumer_declaration_consumer_name(inputs)
	if (locale === "da") return da_consumer_declaration_consumer_name(inputs)
	if (locale === "sv") return sv_consumer_declaration_consumer_name(inputs)
	return en_consumer_declaration_consumer_name(inputs)
});